export const CLEANING_TAX_RATE = 0.06625;

export const formatCurrency = (value) => {
  const amount = Number(value || 0);
  return amount.toFixed(2);
};

export const getTaxInclusiveTotal = (basePrice) => {
  const amount = Number(basePrice || 0);
  return Number((amount * (1 + CLEANING_TAX_RATE)).toFixed(2));
};

export const getBookingPriceBreakdown = (booking = {}) => {
  const basePrice = Number(booking.price || 0);
  const storedTotal = Number(booking.total_price || 0);
  const totalWithTax = storedTotal > basePrice ? storedTotal : getTaxInclusiveTotal(basePrice);

  return {
    basePrice,
    totalWithTax,
    taxAmount: Number((totalWithTax - basePrice).toFixed(2)),
  };
};